module.exports = __webpack_public_path__ + "static/media/gcc-flag.16d43f36.svg";